<template>
  <div>
    <div>
      <!-- list of comments -->
      <comment
        v-for="com in comments"
        :key="com.id"
        :date="com.date"
        :text="com.body"
        :user-name="com.user.name"
        :user-role="com.user.role.label"
      />
    </div>
    <div class="mt-5">
      <div v-if="!showCommentForm && $can('store', 'document_comments')" class="text-right">
        <base-button native-type="button" type="primary" @click="showNewCommentForm">Nuevo comentario</base-button>
      </div>
      <div v-if="showCommentForm">
        <!-- new comment form -->
        <form class="needs-validation" @submit.prevent="saveComment">
          <div class="form-group">
            <label class="control-label">Agregar un comentario</label>
            <el-input
              v-model="formData.body"
              v-validate="modelValidations.body"
              :rows="3"
              name="comment"
              placeholder="Ingrese un comentario sobre el documento"
              type="textarea"
            ></el-input>
            <small v-show="comment.invalid" class="text-danger">
              {{ getError('comment') }}
            </small>
          </div>

          <div class="text-right">
            <base-button native-type="submit" type="primary">Guardar</base-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vee-validate';
import Comment from '@/components/Comment';
import { Checkbox } from 'element-ui';

export default {
  components: {
    Comment,
    [Checkbox.name]: Checkbox,
  },

  props: {
    document: {
      type: Object,
      default: () => ({}),
    },

    comments: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      showCommentForm: false,
      formData: {
        document_id: this.document.id,
        body: '',
      },

      modelValidations: {
        body: {
          required: true,
          min: 3,
          max: 255,
        },
      },
    };
  },

  computed: {
    ...mapFields(['comment']),
  },

  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName);
    },

    async firstFormSubmit() {
      try {
        return await this.$validator.validateAll();
      } finally {
        this.validated = true;
      }
    },

    showNewCommentForm() {
      this.showCommentForm = true;
      this.formData.body = '';
    },

    saveComment() {
      this.firstFormSubmit().then((res) => {
        if (res) {
          this.$emit('addComment', this.formData);
          this.showCommentForm = false;
        }
      });
    },
  },
};
</script>
